import { useState, useEffect } from "react";
import {
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";

import "./i18n/config";
import CardGenerator from "./CardGenerator";
import Login from "Login";
import Admin from "./Admin";
import Analytics from "./Analytics";
import Result from "./Result";
import ScrollToTop from "./utils/scrollToTop";
import Footer from "views/Home/Footer";
import Legal from "Legal";
import Cookies from "Cookies";

import { useTranslation } from "react-i18next";

function App() {
  const [baseDomain, setBaseDomain] = useState(null);
  const [isVerified, setIsVerified] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const hostname = window.location.hostname;

  const tFixed = i18n.getFixedT(currentLanguage, "translations");
  const privacyPath = tFixed("routes.privacyPath");
  const cookiesPath = tFixed("routes.cookiesPath");

  const checkPw = () => {
    // gets the current input value
    const answer = document.getElementById("password").value;

    if (answer === "argeta6712!") {
      setIsVerified(true);
    } else {
      alert("Nope, wrong password.");
    }
  };

  useEffect(() => {
    switch (hostname) {
      case "zgodbarcek.junior-adventures.com":
        i18n.changeLanguage("sl");
        setIsVerified(true);
        setBaseDomain(process.env.REACT_APP_DOMAIN_SL);
        break;
      case "pripovijedac.junior-adventures.com":
        i18n.changeLanguage("hr");
        setIsVerified(true);
        setBaseDomain(process.env.REACT_APP_DOMAIN_HR);
        break;
      case "pripovjedac.junior-adventures.com":
        i18n.changeLanguage("hr");
        setIsVerified(true);
        setBaseDomain(process.env.REACT_APP_DOMAIN_HR_HR);
        break;
      case "pripovedac.junior-adventures.com":
        i18n.changeLanguage("rs");
        setIsVerified(true);
        setBaseDomain(process.env.REACT_APP_DOMAIN_RS);
        break;
      case "geschichtenerzaehler.argeta.com":
        i18n.changeLanguage("de");
        setIsVerified(true);
        setBaseDomain(process.env.REACT_APP_DOMAIN_DE);
        break;
      case "price.junior-adventures.com":
        i18n.changeLanguage("ba");
        setIsVerified(true);
        setBaseDomain(process.env.REACT_APP_DOMAIN_BA);
        break;
      default:
        i18n.changeLanguage("de");
        setIsVerified(true);
        setBaseDomain(process.env.REACT_APP_DOMAIN_DE);
        break;
    }
  }, [hostname, i18n]);

  const LoadAdminView = () => {
    useEffect(() => {
      localStorage.setItem("isAdmin", true);
      navigate("/");
    }, []);

    return <div>{/* Your admin page content here */}</div>;
  };

  if (baseDomain === null) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <ScrollToTop />

      {isVerified ? (
        <>
          <Routes location={location} key={location.pathname}>
            <Route
              path="/"
              element={<CardGenerator baseDomain={baseDomain} />}
            />
            <Route
              path="/result/:userId"
              element={<Result type="sender" baseDomain={baseDomain} />}
            />
            <Route path="/login" element={<Login baseDomain={baseDomain} />} />
            <Route path="/admin" element={<Admin baseDomain={baseDomain} />} />
            <Route
              path="/analytics"
              element={<Analytics baseDomain={baseDomain} />}
            />
            <Route
              path={privacyPath}
              element={<Legal currentLanguage={currentLanguage} />}
            />
            <Route
              path={cookiesPath}
              element={<Cookies currentLanguage={currentLanguage} />}
            />
            <Route path="/adminnja" element={<LoadAdminView />} />
          </Routes>
          <Footer />
        </>
      ) : (
        <div className="vh-100 d-flex align-items-center justify-content-center">
          <form onSubmit={checkPw}>
            <div className="m-2">
              <label htmlFor="password">Password</label>
              <input type="password" name="password" id="password" />
            </div>
            <div className="m-2">
              <button>Login</button>
            </div>
          </form>
        </div>
      )}
    </>
  );
}

export default App;
